import React from "react"
import ArrowLeft from "../assets/icons/arrow-left.svg"

const Camp = () => {
  return (
    <div className="mx-10 mt-20 mb-36">
      {/* BACK */}
      <a className="items-center section-heading font-fontspring" href="/">
        <ArrowLeft className="mr-4" /> Back
      </a>

      {/* INTRO */}
      <div className="flex flex-col items-center">
        <div className="max-w-3xl mt-10 text-center text-azur">
          <p className="text-2xl font-medium">
            The carving camp for hardboot riders
          </p>

          <p className="mt-4">
            Ride with World Cup professionals, refine your carving technique and
            enjoy three unforgettable days on snow.
          </p>

          <p className="mt-6 text-sm uppercase tracking-wide">
            April 1-4, 2027 Scuol, Switzerland
          </p>
        </div>
      </div>

      {/* HERO IMAGE */}
      <img src="/assets/camp.webp" className="w-full mt-12" />

      {/* VIDEO */}
      <div className="flex flex-col items-center mt-16">
        <div className="md:w-[48rem] w-full">
          <h4 className="inline-flex text-2xl border-b-2 border-orange text-orange font-fontspring">
            Camp Vibes
          </h4>

          <p className="mt-4 text-azur">
            Experience the Snowboard Carving Camp in my hometown Scuol - focused
            coaching on snow, great moments off the slopes and relaxed evenings
            at Hotel Belvedere.
          </p>

          <div className="relative mt-8 w-full aspect-video rounded-xl overflow-hidden shadow-lg">
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src="https://www.youtube.com/embed/cGGxIYJKjJo"
              title="SNOWBOARD CARVING CAMP by Nevin Galmarini"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>

      {/* COACHES */}
      <div className="flex flex-col items-center mt-16">
        <div className="md:w-[48rem] w-full">
          <h4 className="inline-flex text-2xl border-b-2 border-orange text-orange font-fontspring">
            Coaches
          </h4>

          <p className="mt-6 text-azur">
            NEVIN GALMARINI (SUI) - Olympic Gold & Silver Medalist, Overall World
            Cup Winner
            <br />
            <span className="italic text-sm">
              More professionals will be announced soon.
            </span>
          </p>
        </div>
      </div>

      {/* PROGRAM */}
      <div className="flex flex-col items-center mt-20">
        <div className="md:w-[48rem] w-full">
          <h4 className="inline-flex text-2xl border-b-2 border-orange text-orange font-fontspring">
            Program
          </h4>

          <ol className="mt-6 list-disc list-inside text-azur space-y-3">
            <li>
              <strong>Thursday, April 1</strong>
              <br />
              Arrival, welcome and dinner
            </li>

            <li>
              <strong>Friday & Saturday, April 2-3</strong>
              <br />
              Full-day riding and coaching sessions
            </li>

            <li>
              <strong>Sunday, April 4</strong>
              <br />
              Special event, camp ends early afternoon
            </li>
          </ol>
        </div>
      </div>

      {/* CAMP PACKAGE */}
      <div className="flex flex-col items-center mt-20">
        <div className="md:w-[48rem] w-full">
          <h4 className="inline-flex text-2xl border-b-2 border-orange text-orange font-fontspring">
            Camp Package
          </h4>

          <ol className="mt-6 list-disc list-inside text-azur space-y-2">
            <li>Professional coaching (English & German)</li>
            <li>3 nights at Hotel Belvedere**** or Hotel GuardaVal****</li>
            <li>Breakfast & dinner included</li>
            <li>3-day lift pass Motta Naluns</li>
            <li>Oxess Snowboards test center</li>
            <li>Free access to Origym fitness & recovery area</li>
          </ol>
        </div>
      </div>

      {/* BOOKING */}
      <div className="flex flex-col items-center mt-24">
        <div className="md:w-[48rem] w-full">
          <h4 className="inline-flex text-2xl border-b-2 border-orange text-orange font-fontspring">
            Booking - Carving Camp 2027 - not yet available!
          </h4>

          <p className="mt-6 text-azur">
            <strong>Date:</strong> 1.-4. April 2027
          </p>

          <ol className="mt-4 list-decimal list-inside text-azur space-y-2">
            <li>Go to the hotel website and click on <strong>Book</strong></li>
            <li>Select the dates 1.-4. April 2027</li>
            <li>Choose your room (single or double)</li>
            <li>
              Enter the discount code{" "}
              <span className="font-bold text-orange">SNOWBOARD26</span>
            </li>
            <li>The complete camp package will be displayed automatically</li>
          </ol>

          <p className="mt-6 text-azur">
            <strong>Prices (excluding taxes):</strong>
            <br />
            CHF 972.- Single room
            <br />
            CHF 1'551.- Double room (2 persons)
          </p>

          <p className="mt-6 text-azur">
            <strong>Payment:</strong> Payment is made on site upon arrival.
          </p>

          <p className="mt-6 text-azur">
            <strong>Accompanying person (without coaching):</strong>
            <br />
            Please mention this in the <strong>Special requests</strong> field
            during booking.
            <br />
            A reduction of <strong>CHF 200.-</strong> will be applied on site.
          </p>

          <a
            href="https://www.belvedere-hotelfamilie.ch"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-10 px-8 py-4 bg-orange text-white font-bold text-lg rounded-lg hover:opacity-90 transition"
          >
            Book your camp now
          </a>
        </div>
      </div>
      {/* QUESTIONS */}
      <div className="flex flex-col items-center mt-24">
        <div className="md:w-[48rem] w-full">
          <h4 className="inline-flex text-2xl border-b-2 border-orange text-orange font-fontspring">
            Questions
          </h4>

          <p className="mt-6 text-azur">
            📩 < a href="mailto:info@nevingalmarini.ch">info@nevingalmarini.ch</a>
          </p>

        </div>
      </div>
    </div>
  )
}

export default Camp
